var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme } from "@mui/material";
import { ItemGraph } from "./ItemGraph";
export var CompareTwoGraph = function (_a) {
    var twoBarsReferenceBar = _a.twoBarsReferenceBar, twoBarsFocusBar = _a.twoBarsFocusBar;
    var theme = useTheme();
    if (!twoBarsFocusBar && !twoBarsReferenceBar) {
        return null;
    }
    var oneHundredPercent = 100;
    var fiftyPercent = 50;
    var minGraphValue = 4;
    var getSmallestGraphValue = function (smallValue, bigValue) {
        var calculatedValue = (smallValue / bigValue) * oneHundredPercent;
        return calculatedValue < minGraphValue ? minGraphValue : calculatedValue;
    };
    var getGraphValue = function (processGraphValue, otherGraphValue, isReference) {
        if (isReference === void 0) { isReference = false; }
        if (!processGraphValue || !otherGraphValue) {
            return isReference ? oneHundredPercent : fiftyPercent;
        }
        return processGraphValue > otherGraphValue
            ? oneHundredPercent
            : getSmallestGraphValue(processGraphValue, otherGraphValue);
    };
    var getFocusGraphColor = function (focusValue, referenceValue) {
        if (!focusValue) {
            return "linear-gradient(0deg, ".concat(theme.palette.primary.main, " 0%, rgba(0, 0, 255, 0) 100%)");
        }
        if (!referenceValue || focusValue <= referenceValue) {
            return theme.palette.primary.main;
        }
        return theme.palette.warning.main;
    };
    var referenceGraphData = {
        value: getGraphValue(twoBarsReferenceBar, twoBarsFocusBar, true),
        isRealValue: Boolean(twoBarsReferenceBar),
        color: twoBarsReferenceBar
            ? theme.palette.grey[200]
            : "linear-gradient(0deg, ".concat(theme.palette.grey[200], " 0%, rgba(228, 231, 236, 0.46) 53.77%, rgba(228, 231, 236, 0.00) 100%)"),
        id: "reference Graph",
    };
    var focusGraphData = {
        value: getGraphValue(twoBarsFocusBar, twoBarsReferenceBar),
        isRealValue: Boolean(twoBarsFocusBar),
        color: getFocusGraphColor(twoBarsFocusBar, twoBarsReferenceBar),
        id: "focus Graph",
    };
    var graphs = [referenceGraphData, focusGraphData];
    return (_jsx(Box, __assign({ sx: { display: "flex", height: "100%", justifyContent: "center" } }, { children: graphs.map(function (graph, index) { return (_jsx(Box, __assign({ sx: { ml: index ? -3 : 0 } }, { children: _jsx(ItemGraph, { value: graph.value, color: graph.color, isRealValue: graph.isRealValue, isMainGraph: graph.value < oneHundredPercent }) }), graph.id)); }) })));
};
